import { Component, inject } from '@angular/core';
import { LayoutService } from '@/layout/service/layout.service';


@Component({
    standalone: true,
    selector: '[app-footer]',
    template: ` <div class="footer-start">
        </div>
        <div class="footer-right">
            <span>V0.0.21</span>
        </div>`,
    host: {
        class: 'layout-footer'
    }
})
export class AppFooter {
    layoutService = inject(LayoutService);
}
